

























































































































































































































































import Pagination from '@/components/lookup/Pagination.vue'
import { genericErrorMessage } from '@/constants'
import { formulaFieldService } from '@/services'
import {
    FormulaContainer,
    FormulaModel,
    FormulaModelType,
} from '@/types/FormulaFieldType'
import { SearchConfigField } from '@/types/utilTypes'
import { generateUniqueId, getAxiosErrors } from '@/utils'
import _ from 'lodash'
import Vue from 'vue'
import FormulasInput from './FormulasInput.vue'

function generateInitialState() {
    return {
        success: false,
        error: false,
        validationErrors: {} as Record<string, string>,
        loading: false
    }
}


function generateInitialFormState() {
    return {
        id: '',
        fieldLabel: '',
        formulas: [] as FormulaModel[],
        state: generateInitialState(),
        deleteDialog:false,
        formulaDialog: false,
    }
}

export default Vue.extend({
    components: { Pagination, FormulasInput},
    props: {
        fields:{
            type: Array as () => SearchConfigField[]
        },
        dialog: {
            type: Boolean,
            default: false
        },
        page: {
            type: String
        }
    },
    watch: {
        async dialog(newVal: boolean) {
            if (newVal) {
                await this.getFormulaFields()

            }
        },
        'form.formulas': {
            handler(newVal: FormulaModel[]) {
                newVal.forEach((formula: FormulaModel) => {
                    this.generateRandomColorForIf(formula)
                })
            },
            deep: true
        }
    },
    data() {
        return {
            search: '',
            tempSearch: '',
            pagination: {
                pageIndex: 1,
                pageSize: 10,
                pages: 1,
                sizes: [
                    5,
                    10,
                    100
                ],
            },
            genericErrorMessage: genericErrorMessage,
            form: generateInitialFormState(),
            loading: false,
            headers: [
                {text: 'Field Label' , value:'fieldLabel'},
                {text: 'Formula Field', value:'formulasString'},
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            colorMap: {} as Record<string, string>,
        }
    },
    methods: {
        async save() {
            await this.processAction(async()=> {
                await formulaFieldService.upsert({
                    id: this.form.id,
                    fieldLabel: this.form.fieldLabel,
                    formulas: this.form.formulas,
                    page: this.page
                })
            })
        },
        setupFormulas(formula: FormulaModel) {
            formula.id = generateUniqueId()
            if (formula.type === FormulaModelType.If) {
                formula.condition.forEach(cond => this.setupFormulas(cond))
                formula.then.forEach(then => this.setupFormulas(then))
                formula.else.forEach(els => this.setupFormulas(els))
            }
        },
        editField(formulaContainer: FormulaContainer) {
            this.form.id = formulaContainer.id
            this.form.fieldLabel = formulaContainer.fieldLabel
            const formulas = _.cloneDeep(formulaContainer.formulas)
            formulas.forEach(formula => this.setupFormulas(formula))
            this.form.formulas = formulas
            this.form.formulaDialog = true
        },
        deleteField(formulaContainer: FormulaContainer) {
            this.form.id = formulaContainer.id
            this.form.fieldLabel = formulaContainer.fieldLabel
            this.form.deleteDialog = true
        },
        async deleteFieldConfirm() {
            await this.processAction(async()=>{
                await formulaFieldService.delete(this.form.id)
                this.form.id = ''
            })
        },
        onSearch() {
            this.search = this.tempSearch.trim()
        },
        onClearSearch() {
            this.search = ''
            this.tempSearch = ''
        },
        onSearchOptionChange(options: { pageIndex?: number, pageSize?: number }) {
            if (options.pageIndex !== undefined) {
                this.pagination.pageIndex = options.pageIndex
            }

            if (options.pageSize !== undefined) {
                this.pagination.pageSize = options.pageSize
            }
        },
        async processAction(callbackFunc: any) {
            try {
                this.form.state = generateInitialState()
                this.form.state.loading = true
                await callbackFunc()
                this.form.state.success = true
                await this.getFormulaFields()
                await this.$store.dispatch('getCurrentPageConfig')
                this.$emit('onFormulaFieldsModification')
            } catch(e) {
                this.form.state.error = true
                this.form.state.validationErrors = getAxiosErrors(e)
            } finally {
                this.form.state.loading = false
            }
        },
        async getFormulaFields() {
            this.loading = true
            await this.$store.dispatch('getFormulaFields', this.page)
            this.loading = false
        },
        clearForm() {
            this.form = generateInitialFormState()
        },
        generateReadableRandomHexColor(): string {
            // Vuetify Material color palettes for lighten-4, lighten-3, lighten-2, lighten-1
            const colorShades = [
                [ // lighten-4
                    '#FFCDD2', '#F8BBD0', '#E1BEE7', '#D1C4E9', '#C5CAE9', '#BBDEFB', '#B3E5FC', '#B2EBF2', '#B2DFDB',
                    '#C8E6C9', '#DCEDC8', '#F0F4C3', '#FFF9C4', '#FFECB3', '#FFE0B2', '#FFCCBC', '#D7CCC8', '#CFD8DC'
                    // '#F5F5F5' removed (very close to #f9f9f9)
                ],
                [ // lighten-3
                    '#EF9A9A', '#F48FB1', '#CE93D8', '#B39DDB', '#9FA8DA', '#90CAF9', '#4FC3F7', '#4DD0E1', '#4DB6AC',
                    '#81C784', '#AED581', '#DCE775', '#FFF176', '#FFD54F', '#FFB74D', '#FF8A65', '#A1887F', '#B0BEC5'
                    // '#E0E0E0' removed (close to #ccc)
                ],
                [ // lighten-2
                    '#E57373', '#F06292', '#BA68C8', '#9575CD', '#7986CB', '#64B5F6', '#29B6F6', '#26C6DA', '#26A69A',
                    '#4CAF50', '#8BC34A', '#D4E157', '#FFEE58', '#FFCA28', '#FFA726', '#FF7043', '#8D6E63', '#90A4AE'
                    // '#BDBDBD' removed (close to #ccc)
                ],
                [ // lighten-1
                    '#EF5350', '#EC407A', '#AB47BC', '#7E57C2', '#5C6BC0', '#42A5F5', '#03A9F4', '#00BCD4', '#009688',
                    '#43A047', '#7CB342', '#C0CA33', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548', '#607D8B'
                    // '#9E9E9E' removed (close to #ccc)
                ]
            ]
            for (let shade = 0; shade < colorShades.length; shade++) {
                const palette = colorShades[shade]
                const available = palette.filter(c => !this.colors.includes(c))
                if (available.length > 0) {
                    return available[Math.floor(Math.random() * available.length)]
                }
            }
            // If all are taken, fallback to a random lighten-4
            const fallback = colorShades[0]
            return fallback[Math.floor(Math.random() * fallback.length)]
        },
        generateRandomColorForIf(formula: FormulaModel): void {
            if (formula.type === FormulaModelType.If) {
                const formulaId = formula.id ?? ''

                if(!this.colorMap[formulaId]) {
                    this.colorMap[formulaId] = this.generateReadableRandomHexColor()
                }

                // Loop each component to check if there are any nested Ifs inside them
                // Then generate a random color for them
                formula.condition.forEach(cond => this.generateRandomColorForIf(cond))
                formula.then.forEach(then => this.generateRandomColorForIf(then))
                formula.else.forEach(els => this.generateRandomColorForIf(els))
            }
        },
    },
    computed: {
        internalFields(): SearchConfigField[] {
            return this.fields.filter(field => !field.isExternalField)
        },
        isActionFinal(): boolean{ 
            return this.form.state.success && !this.form.id
        },
        closeText(): string {
            return this.isActionFinal ? 'Close': 'Cancel'
        },
        formulaFieldStyle(): string {
            let result =  `outline-color: ${this.form.state.validationErrors.Formulas? this.$vuetify.theme.currentTheme.error : this.$vuetify.theme.currentTheme.primary};`
            
            if(this.form.state.validationErrors.Formulas) {
                result += `border-color: ${this.$vuetify.theme.currentTheme.error};`
            }
            return result
        },
        colors(): string[] {
            return Object.values(this.colorMap)
        },
    },
})
